import { Component, OnInit } from '@angular/core';

import * as firebase from 'firebase';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  email: string = "";

  constructor() { }

  ngOnInit() {
  }

  sendEmail() {
    if(!this.email) {
      return alert("Please enter email");
    }

    firebase.auth().sendPasswordResetEmail(this.email)
    .then(() => {
      alert("Email sent with password reset instructions.");
    })
    .catch(err => {
      alert(err.message);
    })
  }

}
